import { render, staticRenderFns } from "./BasicPriceModal.vue?vue&type=template&id=f20f1f04&"
import script from "./BasicPriceModal.vue?vue&type=script&lang=js&"
export * from "./BasicPriceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports